import {PolymerElement, html} from '@polymer/polymer';
import '@polymer/polymer/lib/elements/dom-if.js';
import {MarkdownSharedStylesHTML} from '../shared-styles/markdown.js';
import {formatDateTime} from '../../javascripts/modules/formatDateTime.js';
import {renderKeliMarkdown} from '../../javascripts/modules/renderKeliMarkdown.js';

class KeliDiscussionMessage extends PolymerElement {
  static get template() {
    return html`
${MarkdownSharedStylesHTML}
<style>
  :host {
    display: block;
    margin: 0 0 1px 0;
    padding: 5px 10px;
    background-color: var(--keli-background-color);
    color: var(--keli-text);
  }

  :host(.system-message) {
    background-color: transparent !important;
    font-size: .9em;
  }

  :host(.system-message) #name {
    display: none;
  }

  :host(.system-message) #time {
    margin-left: 0 !important;
  }

  :host(.unsaved) {
    background-color: transparent;
  }

  #message {
    font-size: .9em;
  }

  #information {
    margin-bottom: .1em;
  }

  #name {
    font-weight: 700;
    font-size: .9em;
  }

  #time {
    font-size: .7em;
    margin-left: .7em;
    color: var(--keli-text-subtle);
  }

  :host(:hover) #actions {
    display: inline-block;
  }

  #actions {
    font-size: .7em;
    display: none;
    float: right;
  }
</style>

<div id="information">
  <span id="name">[[person]]</span>
  <span id="time">[[formattedTime]]</span>
  <template is="dom-if" if="[[editAddress]]">
    <span id="actions">
      <keli-a href="[[editAddress]]">Edit</keli-a>
    </span>
  </template>
</div>
<div id="message"></div>`;
  }

  static get is() {
    return 'keli-discussion-message';
  }

  static get properties() {
    return {
      editAddress: String,
      formattedTime: {type: String, computed: 'computeFormattedTime(time)'},
      id: String,
      message: {type: String, observer: 'messageChanged'},
      person: String,
      systemMessage: {type: Boolean, observer: 'systemMessageChanged'},
      time: {type: Date},
      unsaved: {type: Boolean, observer: 'unsavedChanged'}
    }
  }

  computeFormattedTime(time) {
    return formatDateTime(time);
  }

  messageChanged(newValue) {
    if (newValue) {
      renderKeliMarkdown(newValue, this.$.message);
    } else {
      this.$.message.textContent = '';
    }
  }

  systemMessageChanged(newValue) {
    this.classList.toggle('system-message', newValue);
  }

  unsavedChanged(newValue) {
    this.classList.toggle('unsaved', newValue);
  }
}

customElements.define(KeliDiscussionMessage.is, KeliDiscussionMessage);
export {KeliDiscussionMessage};
